export default __webpack_public_path__ + "static/media/blue-oval.d0f2ffa0.png";